/**
 * Age Gate
 *
 * Light DOM web component for site-level age verification.
 */
class FelixAgeGate extends HTMLElement {
	connectedCallback() {
		this.confirmButton = this.querySelector('.age-gate-overlay__confirm')
		this.panel = this.querySelector('.age-gate-overlay__panel')

		this.cookieName = this.dataset.cookieName || 'felix_age_gate_verified'
		this.expiryDays = this.parseExpiryDays(this.dataset.expiryDays)

		if (this.hasCookie(this.cookieName)) {
			this.hideImmediately()
			return
		}

		this.lockScroll()
		this.bindEvents()
		this.focusPrimaryAction()
	}

	disconnectedCallback() {
		if (this.confirmButton) {
			this.confirmButton.removeEventListener('click', this.handleConfirm)
		}
		this.unlockScroll()
	}

	parseExpiryDays(rawValue) {
		const parsed = Number.parseInt(rawValue || '30', 10)
		if (!Number.isFinite(parsed) || parsed < 1) {
			return 30
		}
		return Math.min(parsed, 365)
	}

	bindEvents() {
		this.handleConfirm = this.onConfirm.bind(this)

		if (this.confirmButton) {
			this.confirmButton.addEventListener('click', this.handleConfirm)
		}
	}

	hasCookie(name) {
		return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${name}=`))
	}

	setCookie(name, value, days) {
		const maxAge = days * 24 * 60 * 60
		const secure = window.location.protocol === 'https:' ? '; Secure' : ''
		document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`
	}

	focusPrimaryAction() {
		if (this.confirmButton && typeof this.confirmButton.focus === 'function') {
			this.confirmButton.focus()
		}
	}

	lockScroll() {
		document.documentElement.classList.add('felix-age-gate-active')
		document.body.classList.add('felix-age-gate-active')
	}

	unlockScroll() {
		document.documentElement.classList.remove('felix-age-gate-active')
		document.body.classList.remove('felix-age-gate-active')
	}

	hideImmediately() {
		this.classList.add('is-hidden')
		this.setAttribute('aria-hidden', 'true')
		this.unlockScroll()
		document.documentElement.classList.add('felix-age-gate-verified')
	}

	hideWithTransition() {
		this.classList.add('is-hidden')
		this.setAttribute('aria-hidden', 'true')
		this.unlockScroll()
		document.documentElement.classList.add('felix-age-gate-verified')
	}

	onConfirm(event) {
		event.preventDefault()
		this.setCookie(this.cookieName, '1', this.expiryDays)
		this.hideWithTransition()
	}

}

customElements.define('felix-age-gate', FelixAgeGate)
